import React, { FC } from 'react';
import classNames from 'classnames';

import { Input, InputProps } from '../Input';
import { formatPhoneNumber } from './phone-input-helpers';

import styles from './PhoneInput.module.scss';

export type PhoneInputProps = InputProps & {
  value: string;
  customInput?: typeof Input;
};

export const PhoneInput: FC<PhoneInputProps> = ({
  value,
  customInput: InputComponent = Input,
  ...props
}) => {
  const phoneNumber = formatPhoneNumber(value);

  const _classNames = classNames(styles.main, props.className, {
    [styles.disabledPlus]: !phoneNumber || props.disabled,
  });

  return (
    <InputComponent { ...props }
                    value={phoneNumber}
                    className={_classNames} />
  );
};
